import { createFileRoute } from "@tanstack/react-router";
import AdminMicrolearningDetailPage from "@/pages/admin/lms/microlearnings/detail";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/microlearnings/$microlearningId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { microlearningId } = Route.useParams();
  const {
    userCanAssociateMaterialsAndCriteria,
    userCanAssociateMaterialsAndTags,
    userCanAssociateMaterialsAndUserFunctions,
    userCanEditAllMaterials,
    userCanViewAllCriteria,
    userCanViewAllMaterials,
    userCanViewAllSettingTags,
    userCanViewAllTags,
  } = useLmsPermissions();

  return (
    <AdminMicrolearningDetailPage
      id={Number(microlearningId)}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
      userCanAssociateMaterialsAndTags={userCanAssociateMaterialsAndTags}
      userCanAssociateMaterialsAndUserFunctions={userCanAssociateMaterialsAndUserFunctions}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
